import { IOptionAnyValue } from 'bricks/types';
import { ProFormaModelIds } from 'constants/proForma';
import { IExpense } from 'views/ProFormaSetup/hooks/useExpenses';
import { IOtherIncome, IUnitMix, ITenant, IExpenses } from 'views/ProFormaSetup/types';
import { IGrossBuildableAreaLotsData } from 'views/ProFormaTable/types';
import { OperatingInfoValues } from './Operations/components/OperatingInfo/OperatingInfo';
import { ISource } from './Development/Sources/Source/types';

export interface BasicInformationValues {
    buildings: number;
    builtGrossSquareFootage: number;
    stories: number;
    sellingCosts: number;
    projectedCapRateAtSale: number;
    currentMarketCapRate: number;
    parking: IOptionAnyValue[];
    structuredParkingSpaces: number | null;
    surfaceParkingSpaces: number | null;
    undergroundParkingSpaces: number | null;
    trailerParkingSpaces: number | null;
    startDate: Date | null;
    constructionStart: Date | null;
    constructionDuration: number;
    holdPeriod: number;
    grossBuildableUnit: string;
    calculateArea: boolean;
    buildableLots: IGrossBuildableAreaLotsData;
}

export interface DevelopmentValues {
    acquisitionCosts: number;
    hardCosts: number;
    totalHardCosts: number;
    softCosts: number;
    totalSoftCosts: number;
    interestReserve: number;
    developerFee: number;
    developerFeeAmount: number;
    sources: ISource[];
    hardCostType: string;
    softCostType: string;
}

export interface OperationsValues {
    unitArray: IUnitMix[];
    tenantArray: ITenant[];
    incomeArray: IOtherIncome[];
    operatingInfoValues: OperatingInfoValues;
    expensesValues: IExpenses;
    expensesDetail: IExpense[];
}

export interface ProFormaQuickStartValues {
    basicInformation: BasicInformationValues;
    development: DevelopmentValues;
    operations: OperationsValues;
}

export const AssetTypeToProFormaModelIdMap: Record<string, ProFormaModelIds> = {
    apartment: ProFormaModelIds.APARTMENT,
    industrial: ProFormaModelIds.INDUSTRIAL,
    retail: ProFormaModelIds.RETAIL,
    ofice: ProFormaModelIds.OFFICE,
    data_center: ProFormaModelIds.DATA_CENTER,
    apartmentWithRetail: ProFormaModelIds.APARTMENT_WITH_RETAIL,
};
